var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Default dashboard for "+_vm._s(_vm.product)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }